//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  Box,
  Divider,
  Flex,
  Progress,
  SimpleGrid,
  Stack,
  Text,
  useToast,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import Pluralize from "pluralize";
import React from "react";
import { useOverlayDisclosure } from "../../components/OverlayRouter";
import Icon from "../../components/ui-elements/Icon";
import { useMedia } from "../../components/ui-elements/SizeDetector";
import { IRequestFlowStore } from "../../stores";
import { scrollToId } from "../../utils/functions";
import { Navigation } from "../Navigation";
import ChildFormPage from "./ChildFormPage";
import FormWrapper from "./components/FormWrapper";
import LessonLocationPage from "./LessonLocationPage";
import LessonSchedulePage from "./LessonSchedulePage";
import ParentFormPage from "./ParentFormPage";
import TeacherFormPage from "./TeacherFormPage";
import { TutorExistsModal } from "./TutorsExistModal";
import LessonScheduleFormPage from "../../new-request-flow/pages/SearchResultPage/NewLessonSchedulePage";
import { LessonScheduleSwitcher } from "./LessonScheduleSwitcher";

type ClientRequestFormProps = {
  viewModel: IRequestFlowStore;
  loaded: boolean;
  country?: string;
  onSubmit: any;
  toggleSubmission?: any;
  discountFlag?: boolean;
  isAdmin?: boolean;
  toggleLayout?: any;
  code?: string;
  [key: string]: any;
};

export const StandaloneRequestForm: React.FC<{
  viewModel: IRequestFlowStore;
  [key: string]: any;
}> = observer(({ viewModel, onSubmit, toggleSubmission }) => {
  const stepsArray = [
    { key: "child-details", name: "Child details", completed: false },
    {
      key: "teacher-selection",
      name: "Teacher selection",
      completed: false,
    },
    { key: "lesson-schedule", name: "Lesson schedule", completed: false },
    { key: "lesson-location", name: "Lesson location", completed: false },
    { key: "contact-information", name: "Contact info", completed: false },
  ];
  const [formIndex, setFormIndex] = React.useState(1);
  const [loadingText, setLoadingText] = React.useState("");
  const { isOpen, onOpen, onClose } = useOverlayDisclosure("/modal");

  const [steps, setSteps] = React.useState(stepsArray);
  const [activeStep, setActiveStep] = React.useState("child-details");
  const handleFormSubmit = (id, presentStep) => {
    setFormIndex((index) => index + 1);
    setActiveStep(id);
    setSteps(
      [...steps].map((object) => {
        if (object.key === presentStep) {
          return {
            ...object,
            completed: true,
          };
        } else return object;
      })
    );
    scrollToId(id);
  };

  return (
    <FormWrapper activeForm={formIndex}>
      <ChildFormPage
        dataType={viewModel.academicData}
        viewModel={viewModel.childStore}
        customerType={viewModel.customerType}
        loading={viewModel.loading}
        updateFormIndex={() => setFormIndex(1)}
        toNextPage={() => {
          viewModel.onSubmit("student-details").then(() => {
            let keys = Object.keys(viewModel.childStore.teacherSplitOptions);
            if (
              keys.length > 0 &&
              !viewModel.teacherSelectStore.teacherOption
            ) {
              viewModel.teacherSelectStore.updateField({
                teacherOption: keys[0],
              });
            }
            handleFormSubmit("teacher-selection", "child-details");
          });
        }}
      />

      <TeacherFormPage
        onSubmit={(data) => {
          // setFormIndex(2)
          viewModel.onSubmit("teacher-selection", data).then(() => {
            handleFormSubmit("lesson-schedule", "teacher-selection");
          });
        }}
        updateFormIndex={() => setFormIndex(2)}
        loading={viewModel.loading}
        teacherSplitOptions={viewModel.childStore.teacherSplitOptions}
        viewModel={viewModel.teacherSelectStore}
      />

      <LessonSchedulePage
        loading={viewModel.loading}
        viewModel={viewModel.lessonScheduleStore}
        splitRequests={viewModel.childStore.splitRequests}
        numberOfTeachers={viewModel.childStore.numberOfTeachers}
        teacherOption={viewModel.teacherSelectStore.teacherOption}
        onSubmit={(data) => {
          viewModel.onSubmit("lesson-schedule", data).then(() => {
            handleFormSubmit("lesson-location", "lesson-schedule");
          });
        }}
      />

      <LessonLocationPage
        loading={viewModel.loading}
        formInitialValues={viewModel.lessonLocationStore.asJSON}
        locationSelectorVM={viewModel.lessonLocationStore}
        onSubmit={(data) => {
          return viewModel
            .onSubmit("lesson-location", data)
            .then(() => {
              handleFormSubmit("contact-information", "lesson-location");
            })
            .catch((error) => {
              console.log(error);
            });
        }}
      />

      <ParentFormPage
        loading={viewModel.loading}
        viewModel={viewModel.contactInfoStore}
        loadingText={loadingText}
        onSubmit={(data) => {
          setLoadingText("Saving");
          return viewModel
            .onSubmit("contact-information", data)
            .then((tutorExistsResult) => {
              setLoadingText("Loading");
              if (
                Array.isArray(tutorExistsResult) &&
                tutorExistsResult.length > 0
              ) {
                onOpen();
              } else {
                toggleSubmission();
                onSubmit();
              }
            });
        }}
      />
    </FormWrapper>
  );
});

export const ClientRequestForm: React.FC<ClientRequestFormProps> = observer(
  ({
    viewModel,
    loaded,
    onSubmit,
    toggleSubmission,
    discountFlag = false,
    isAdmin = false,
    toggleLayout,
    country,
    code,
    ...rest
  }) => {
    const percentObj = {
      "child-details": 20,
      "teacher-selection": 40,
      "lesson-schedule": 60,
      "lesson-location": 80,
      "contact-information": 100,
    };

    const stepsArray = [
      { key: "child-details", name: "Child details", completed: false },
      { key: "teacher-selection", name: "Teacher selection", completed: false },
      { key: "lesson-schedule", name: "Lesson schedule", completed: false },
      { key: "lesson-location", name: "Lesson location", completed: false },
      { key: "contact-information", name: "Contact info", completed: false },
    ];
    const toast = useToast();
    const isMobile = useMedia("(max-width: 420px)");
    const [formIndex, setFormIndex] = React.useState(1);
    const { isOpen, onOpen, onClose } = useOverlayDisclosure("/modal");
    const [loadingText, setLoadingText] = React.useState("");
    const [steps, setSteps] = React.useState(stepsArray);
    const [activeStep, setActiveStep] = React.useState("child-details");

    React.useEffect(() => {
      if (discountFlag) {
        toast({
          title: "Discount wasn't applied",
          position: isMobile ? "bottom" : "bottom-left",
          description: "You have used it previously",
          status: "warning",
          duration: 9000,
          isClosable: true,
        });
      }
    }, [discountFlag]);

    const handleFormSubmit = (id, presentStep) => {
      setFormIndex((index) => index + 1);
      setActiveStep(id);
      setSteps(
        [...steps].map((object) => {
          if (object.key === presentStep) {
            return {
              ...object,
              completed: true,
            };
          } else return object;
        })
      );
      scrollToId(id);
    };
    return (
      <Box minH="100vh" bg={["white", "neutral.200"]} {...rest}>
        <Navigation logoPosition="left" py={[5, 5]}>
          <Stack spacing={[2, 3]} isInline align="center">
            <Progress
              colorScheme="green"
              size="sm"
              width={[20, 24, 48]}
              rounded="md"
              value={percentObj[activeStep]}
            />
            <Text
              fontSize="sm"
              fontWeight="medium"
              color="green.500"
            >{`${percentObj[activeStep]}%`}</Text>
          </Stack>
        </Navigation>

        <RequestFormWrapper
          formIndex={formIndex}
          viewModel={viewModel}
          activeStep={activeStep}
          steps={steps}
        >
          <TutorExistsModal
            isLoading={viewModel.loading}
            onSubmit={() => {
              onClose();
              onSubmit();
            }}
            foundNoResult={
              viewModel.splitRequests.length === viewModel.splitToExclude.length
            }
            teachersRequested={viewModel.splitRequests.length}
            isOpen={isOpen}
            onClose={onClose}
          />
          <FormWrapper activeForm={formIndex}>
            <ChildFormPage
              dataType={viewModel.academicData}
              viewModel={viewModel.childStore}
              customerType={viewModel.customerType}
              loading={viewModel.loading}
              updateFormIndex={() => setFormIndex(1)}
              toNextPage={() => {
                viewModel.onSubmit("student-details").then(() => {
                  let keys = Object.keys(
                    viewModel.childStore.teacherSplitOptions
                  );
                  if (
                    keys.length > 0 &&
                    !viewModel.teacherSelectStore.teacherOption
                  ) {
                    viewModel.teacherSelectStore.updateField({
                      teacherOption: keys[0],
                    });
                  }
                  handleFormSubmit("teacher-selection", "child-details");
                });
              }}
            />

            <TeacherFormPage
              onSubmit={(data) => {
                // setFormIndex(2)
                viewModel.onSubmit("teacher-selection", data).then(() => {
                  handleFormSubmit("lesson-schedule", "teacher-selection");
                });
              }}
              initialValues={{
                ...viewModel.teacherSelectStore.toJSON(),
                gender: viewModel.filterStore.gender.toJSON(),
              }}
              updateFormIndex={() => setFormIndex(2)}
              loading={viewModel.loading}
              teacherSplitOptions={viewModel.childStore.teacherSplitOptions}
              viewModel={viewModel.teacherSelectStore}
            />

            <LessonScheduleSwitcher
              splitInfo={viewModel.splitInfo}
              toggleLayout={toggleLayout}
              viewModel={viewModel.lessonScheduleStore}
              numberOfTeachers={viewModel.childStore.numberOfTeachers}
              isMultipleSchedule={isAdmin}
              loading={viewModel.loading}
              teacherOption={viewModel.teacherSelectStore.teacherOption}
              onSubmit={(data) => {
                viewModel.onSubmit("lesson-schedule", data).then(() => {
                  handleFormSubmit("lesson-location", "lesson-schedule");
                });
              }}
              onScheduleSubmit={() => {
                viewModel.onSubmit("children-schedule").then(() => {
                  handleFormSubmit("lesson-location", "children-schedule");
                });
              }}
            />

            <LessonLocationPage
              loading={viewModel.loading}
              formInitialValues={viewModel.lessonLocationStore.asJSON}
              defaultCountry={country}
              countryCode={code}
              locationSelectorVM={viewModel.lessonLocationStore}
              onSubmit={(data) => {
                return viewModel
                  .onSubmit("lesson-location", data)
                  .then(() => {
                    handleFormSubmit("contact-information", "lesson-location");
                  })
                  .catch((error) => {
                    console.log(error);
                  });
              }}
            />

            <ParentFormPage
              loading={viewModel.loading}
              viewModel={viewModel.contactInfoStore}
              country={viewModel.contactInfoStore.country}
              country_code={viewModel.contactInfoStore.country_code}
              loadingText={loadingText}
              onSubmit={(data) => {
                setLoadingText("Saving");
                return viewModel
                  .onSubmit("contact-information", data)
                  .then((tutorExistsResult) => {
                    setLoadingText("Loading");
                    // if (!isAdmin) {
                    //   if (
                    //     Array.isArray(tutorExistsResult) &&
                    //     tutorExistsResult.length > 0
                    //   ) {
                    //     onOpen();
                    //   } else {
                    //     toggleSubmission();
                    //     onSubmit();
                    //   }
                    // } else {
                    //   onSubmit();
                    // }
                    onSubmit();
                  });
              }}
            />
          </FormWrapper>
        </RequestFormWrapper>
      </Box>
    );
  }
);

export const RequestFormWrapper = ({
  viewModel,
  formIndex,
  steps,
  activeStep,
  children,
  ...rest
}) => {
  return (
    <Box {...rest}>
      <Box width="100%">
        <Flex
          flexGrow={1}
          align="stretch"
          minW="320px"
          flexShrink={0}
          width="100%"
          boxSizing="border-box"
          justifyContent="center"
        >
          {/* <FormList
              activeStep={activeStep}
              formIndex={formIndex}
              steps={steps}
            /> */}
          <Stack
            maxW={["100%", "100%", "680px"]}
            width="100%"
            flex={1}
            flexShrink={0}
            minH="calc(100vh - 62px)"
            justifyContent="stretch"
            align="stretch"
            mx={[0, 8, 10]}
          >
            {children}
          </Stack>
          {/* <Box
              top={16}
              maxW="360px"
              minW="300px"
              position="sticky"
              height="fit-content"
              display={play={["none", "none", "none", "none", "block"]}
            >
              <FormSummary viewModel={viewModel} />
            </Box> */}
        </Flex>
      </Box>
    </Box>
  );
};
let uu: any = "";
export const replaceAll = uu.replaceAll
  ? (str, find, rep) => str.replaceAll(find, rep)
  : (str, find, rep) => str.split(find).join(rep);

const FormSummary = ({ viewModel }) => {
  const childDetails = viewModel.childStore.childDetails;
  const lessonSchedule = viewModel.lessonScheduleStore;
  const lessonType = viewModel.lessonLocationStore.lessonType;

  const removeUnderScore = (word) => replaceAll(word, "_", " ");
  // const removeUnderScore = (word) => word.replaceAll("_", " ");

  const getClosingTime = (lessonTime, lessonHours) => {
    const [time, modifier] = lessonTime.split(" ");
    let [hours, minutes] = time.split(":");
    if (hours === "12") {
      hours = "00";
    }
    if (modifier === "PM") {
      hours = parseInt(hours, 10) + 12;
    }
    const finalTime = `${parseInt(hours) + lessonHours}:${minutes}`;
    const [sHours, sminutes] = finalTime
      .match(/([0-9]{1,2}):([0-9]{2})/)
      .slice(1);
    const period = +sHours < 12 ? "AM" : "PM";
    const shours = +sHours % 12 || 12;
    return `${shours}:${sminutes} ${period}`;
  };

  return (
    <Stack p={[5, 6]} spacing={[3, 4]}>
      <Text fontSize="lg" fontWeight="semibold">
        Your booking
      </Text>

      <Stack spacing={[2, 3]} fontSize="xs">
        <Text textDecoration="underline" color="green.500">
          Child's summary
        </Text>
        {childDetails.map(({ firstName, classDetail }, idx) => (
          <Box key={idx}>
            <Text fontWeight="medium">
              {firstName}, {classDetail.class}
            </Text>
            <Flex justify="space-between" opacity={0.8}>
              <Text>{removeUnderScore(classDetail.purpose)}</Text>
              <Text>
                {Pluralize("subject", classDetail.subjects.length, true)}
              </Text>
            </Flex>
          </Box>
        ))}
      </Stack>

      <Divider />

      <Stack spacing={[2, 3]} fontSize="xs">
        <Text textDecoration="underline" color="green.500">
          Tutor's summary
        </Text>
        <Text>{`${viewModel.teacherSelectStore.teacherOption}`}</Text>
      </Stack>

      <Divider />

      <Stack spacing={[2, 3]} fontSize="xs">
        <Text textDecoration="underline" color="green.500">
          Schedule's summary
        </Text>
        <SimpleGrid columns={2} fontSize="xs" spacing={[3, 4]}>
          <Stack isInline align="center" lineHeight="none">
            <Icon name="time" size={3} />
            <Text>{`${lessonSchedule.lessonTime} - ${getClosingTime(
              lessonSchedule.lessonTime,
              lessonSchedule.lessonHours
            )}`}</Text>
          </Stack>

          <Stack isInline align="center" lineHeight="none">
            <Icon name="calendar-outline" size={3} />
            <Text>{`${lessonSchedule.lessonDays.length} days per week`}</Text>
          </Stack>

          <Stack isInline align="center" lineHeight="none">
            <Icon name="view" size={3} />
            <Text>{lessonType}</Text>
          </Stack>

          <Stack isInline align="center" lineHeight="none">
            <Icon name={"time"} size={3} />
            <Text>{lessonSchedule.lessonUrgency}</Text>
          </Stack>
        </SimpleGrid>
      </Stack>

      <Divider />
    </Stack>
  );
};

const FormList = ({ activeStep, formIndex, steps, ...rest }) => {
  return (
    <Stack
      p={8}
      top={16}
      spacing={6}
      position="sticky"
      height="100%"
      display={["none", "none", "none", "block"]}
      maxW="360px"
      minW="300px"
      {...rest}
    >
      {steps.map((item, index) => {
        const isActive = activeStep === item.key;
        return (
          <Box key={index}>
            {item.completed ? (
              <Stack spacing={3} isInline align="center">
                <Icon name="check-circle" size={8} color="green.500" />
                <Text fontWeight="medium">{item.name}</Text>
              </Stack>
            ) : (
              <Stack spacing={3} isInline align="center">
                <Flex
                  size={8}
                  justifyContent="center"
                  align="center"
                  rounded="full"
                  borderWidth="xs"
                  borderColor={isActive ? "green.500" : "inherit"}
                  color={isActive ? "green.500" : "inherit"}
                >
                  {index + 1}
                </Flex>
                <Text fontWeight="medium">{item.name}</Text>
              </Stack>
            )}
          </Box>
        );
      })}
    </Stack>
  );
};

export default ClientRequestForm;
